import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { CollabDocBarComponent } from './collab-doc-bar.component';

@NgModule({
  declarations: [
    CollabDocBarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatToolbarModule,
    PluralizeModule
  ],
  exports: [
    CollabDocBarComponent
  ]
})
export class CollabDocBarModule { }
